import { type FormEvent, useEffect, useState } from "react";
import { useStaffMessagingPreferences, type StaffMessagingPreferences } from "../../hooks/useStaffMessagingPreferences";
import { apiRequest } from "../../lib/api";
import { useToast } from "../../context/ToastContext";

export function MessageSendingSettings() {
  const result = useStaffMessagingPreferences();
  const { showToast } = useToast();
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (result.data) setEnabled(result.data.undoSendEnabled); }, [result.data]);
  async function save(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    try {
      const saved = await apiRequest<StaffMessagingPreferences>("/agent/profile/messaging", {
        method: "PUT", body: { undoSendEnabled: enabled },
      });
      result.setData(saved);
      showToast("Message sending preference saved.", "success");
    } catch (error) {
      showToast(error instanceof Error ? error.message : "Preference could not be saved.", "error");
    } finally { setBusy(false); }
  }
  return <section className="settings-section card">
    <header><div><h2>Message sending</h2><p>Saved for your staff account across devices. Off by default.</p></div></header>
    <form className="inline-admin-form" onSubmit={save}>
      {result.error && <div className="form-alert" role="alert">{result.error} <button type="button" onClick={() => void result.refresh()}>Retry</button></div>}
      <label className="check-field"><input type="checkbox" checked={enabled} disabled={busy || result.loading || !!result.error} onChange={(event) => setEnabled(event.target.checked)} /><span>Wait 10 seconds before sending a reply or internal note</span></label>
      <p>During the countdown, choose Cancel send to keep editing. Nothing is uploaded or added to the ticket until the countdown ends. Leaving the ticket cancels a pending send; keep this page open until sending finishes.</p>
      <div className="form-actions"><button type="submit" className="button button--primary" disabled={busy || result.loading || !!result.error || enabled === result.data?.undoSendEnabled}>{busy ? "Saving…" : "Save preference"}</button></div>
    </form>
  </section>;
}
